/**
 * @vuepress
 * ---
 * title: Advance Report
 */

import Transformer from '../transformer'
import { Counterproposal, MinimalBudget } from '@/transformers/Budget'
import { minimalSinister } from '@/transformers/sinister'
import { parentPrefixTransformer } from '@/transformers/utils'

const authorizationTransform = ({
  authorization_request_date: authorizationRequestDate,
  authorization_date: authorizationDate,
  second_authorization_request_date: secondAuthorizationRequestDate,
  authorization_date_client: authorizationDateClient,
  authorization_approval_time: authorizationApprovalTime
}) => {
  return {
    authorizationRequestDate,
    authorizationDate,
    secondAuthorizationRequestDate,
    authorizationDateClient,
    authorizationApprovalTime
  }
}

class AuthorizationsFollowUpReport extends Transformer {
  static fetch({
    affected,
    sinister,
    budget,
    budget_authorizations: budgetAuthorizations,
    approval_time: approvalTime,
    approval_time_client: approvalTimeClient,
    counterproposal
  }) {
    const budgetTransformed = budget ? parentPrefixTransformer('budget', MinimalBudget.fetch(budget)) : null
    return {
      ...budgetTransformed,
      ...parentPrefixTransformer('budget', authorizationTransform(budgetAuthorizations)),
      ...parentPrefixTransformer('sinister', minimalSinister.fetch(sinister)),
      ...Counterproposal.fetch(counterproposal),
      affected,
      approvalTime,
      approvalTimeClient
    }
  }
}
export default AuthorizationsFollowUpReport
